var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSharingPermissionsStage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.96875C4.58731 8.96875 5.46875 8.08731 5.46875 7C5.46875 5.91269 4.58731 5.03125 3.5 5.03125C2.41269 5.03125 1.53125 5.91269 1.53125 7C1.53125 8.08731 2.41269 8.96875 3.5 8.96875Z",
    stroke: "#000000",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.4688C11.5873 12.4688 12.4688 11.5873 12.4688 10.5C12.4688 9.41269 11.5873 8.53125 10.5 8.53125C9.41269 8.53125 8.53125 9.41269 8.53125 10.5C8.53125 11.5873 9.41269 12.4688 10.5 12.4688Z",
    stroke: "#000000",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.46875C11.5873 5.46875 12.4688 4.58731 12.4688 3.5C12.4688 2.41269 11.5873 1.53125 10.5 1.53125C9.41269 1.53125 8.53125 2.41269 8.53125 3.5C8.53125 4.58731 9.41269 5.46875 10.5 5.46875Z",
    stroke: "#000000",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.875L8.75 9.625M5.25 6.125L8.75 4.375",
    stroke: "#000000",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharingPermissionsStage);
export default __webpack_public_path__ + "static/media/icon--sharing-permissions-stage.7a9ab0ea9c373afa940f082108f3e9ab.svg";
export { ForwardRef as ReactComponent };